<script setup>
import { toRefs } from "vue";

const props = defineProps({
  title: {
    type: String,
  },
  info: {
    type: String,
  },
  type: {
    type: String,
    default: "string",
  },
});

const { title, info } = toRefs(props);
</script>

<template>
  <div class="info pa-2">
    <p>
      <span class="label mb-1">{{ title }}</span>
    </p>
    <div v-if="type === 'boolean'" class="answer">
      <v-icon v-if="info"> mdi-check-circle </v-icon>
      <v-icon v-else> mdi-close-circle </v-icon>
    </div>
    <div v-else-if="type === 'richText'" class="answer-no-bold">
      <span v-html="info" />
    </div>
    <div v-else class="answer">
      {{ info ? info : "-" }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 48px;
}
.box-row {
  gap: 20px;
  .box-container {
    border: 1px solid rgb(var(--v-theme-primary));
    h3 {
      background-color: rgb(var(--v-theme-primary));
      color: white;
    }
    .info {
      .label {
        text-decoration: underline;
      }
      .answer {
        display: block;
        font-weight: bold;
      }
    }
  }
}
</style>
